<template>
  <section>
    <b-modal width="680px" :active.sync="isModalRoboApplyActive" :on-cancel="closeRoboApplyModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">ロボの割り当て</span>
          </div>
        </header>
        <div class="card-content" style="text-align: center; border-radius: 5px;">
          <div>
            <img :src="getRoboIcon(selectRobo)" style="height: 150px; width: 150px; object-fit: cover; border-radius: 50%; border: solid thin #ccc;"/>
          </div>
          <div class="apply-box">
            <b-select v-model="selectRobo" placeholder="適用するロボを選択" style="width: 100%;" :disabled="getRoboList.length==0">
              <option v-for="(robo, index) in getRoboList" :key="index" :value="robo">
                {{ robo.data.name }}
              </option>
            </b-select>
          </div>
        </div>
        <button @click="returnRoboApplyModal(selectRobo)" style="height: 50px;" class="button is-primary is-fullwidth" :disabled="!selectRobo">ロボを割り当てる</button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ModalSitemapRoboApply',
  componentName: 'ModalSitemapRoboApply',
  computed: {
    getRoboList () {
      // 適用済みのロボとミニロボを除いた一覧取得
      if (this.applyRoboTargetSitemamp) {
        const robo_list = this.applyRoboTargetSitemamp.apply_robo_list
        const minirobo_rist = this.applyRoboTargetSitemamp.apply_minirobo_list
        const xorRoboList = _.xorBy(this.roboList, robo_list, minirobo_rist, 'data.bot_id')
        const confirmXorRoboList = []
        for (var i of _.orderBy(xorRoboList, ['data.name'], ['asc'])) {
          if (i.data.is_confirm) {
            confirmXorRoboList.push(i)
          }
        }
        return confirmXorRoboList
      }
    }
  },
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isModalRoboApplyActive: this.isSitemapRoboApplyModalOpen,
      /** 選択中ロボ */
      selectRobo: null
    }
  },
  props: {
    /** モーダルダイアログ開閉フラグ */
    isSitemapRoboApplyModalOpen: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** 求人ページフラグ */
    isRecruit: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** ロボ適用先サイトマップ */
    applyRoboTargetSitemamp: {
      required: true
    },
    /** ロボリスト */
    roboList: {
      required: true
    }
  },
  watch: {
    /** モーダルダイアログ開閉フラグ */
    isSitemapRoboApplyModalOpen () {
      this.isModalRoboApplyActive = this.isSitemapRoboApplyModalOpen
    }
  },
  methods: {
    /** ロボアイコン取得 */
    getRoboIcon (selectRobo) {
      let icon = null
      if (!selectRobo) {
        icon = require('@/assets/template/robot.png')
      } else if (selectRobo.data.icon) {
        icon = selectRobo.data.icon
      } else if (selectRobo.data.icon_ref) {
        icon = selectRobo.data.icon_ref
      } else if (selectRobo.data.default_icon_ref) {
        icon = selectRobo.data.default_icon_ref
      } else {
        icon = require('@/assets/template/robot.png')
      }
      return icon
    },
    /** ロボ適用結果返却 */
    returnRoboApplyModal (selectRobo) {
      this.$emit('returnRoboApplyModal', this.applyRoboTargetSitemamp, selectRobo, this.isRecruit)
      this.selectRobo = null
    },
    /** ロボ適用ダイアログクローズ */
    closeRoboApplyModal () {
      this.$emit('closeRoboApplyModal')
      this.selectRobo = null
    }
  }
}
</script>

<style scoped>
.apply-box {
  height: 100%;
  overflow: auto;
  width: 100%;
  border-radius: 5px;
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  align-items: center;
  flex-direction: column;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.split-box-form {
  width: 100%;
  display: flex;
  padding-bottom: 24px;
}
.split-box-left {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.split-box-right {
  width: 80%;
  font-size: 13px;
  padding-right: 48px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/users/sitemap/ModalSitemapRoboApply.vue